"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MongoLogChannel = void 0;
const OnlineResourceManager_1 = require("../OnlineResourceManager/OnlineResourceManager");
class MongoLogChannel {
    constructor() {
        this.log = (logEntry) => {
            const onlineResource = this.onlineResourceManager.makeJSONRequest("/api/logs", "POST", JSON.stringify(logEntry, this.sanitizeLog));
            onlineResource.getResponseData().catch(() => {
                onlineResource.getResponseData();
            });
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.sanitizeLog = (key, value) => {
            if (key === "message") {
                return value.length >= 255 ? value.substring(0, 244) + "<truncated>" : value;
            }
            return value;
        };
        this.onlineResourceManager = new OnlineResourceManager_1.OnlineResourceManager();
    }
}
exports.MongoLogChannel = MongoLogChannel;
